/**
* 风控的设备详情 IOS
*/
<template>
	<div
		style="display: flex; flex-direction: column; height: 100vh; background: #f5f7fa; overflow: hidden; font-family: sans-serif;">

		<van-overlay :show="loadingData" style="z-index: 9999;">
			<div style="display: flex; align-items: center; justify-content: center; height: 100%;">
				<van-loading size="24px" vertical color="#409EFF">{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div
			style="flex-shrink: 0; background: #fff; padding: 15px 20px; box-shadow: 0 2px 10px rgba(0,0,0,0.05); z-index: 10;">
			<div v-show="successfulOperation || operationFailed" style="margin-bottom: 12px;">
				<el-alert v-show="successfulOperation" :title="message" type="success" center show-icon />
				<el-alert v-show="operationFailed" :title="message" type="error" center show-icon />
			</div>
			<div style="display: flex; justify-content: center; gap: 12px;">
				<el-button size="medium" style="width: 30%;" type="warning"
					@click="banAccount()">{{ text02 }}</el-button>
				<el-button size="medium" style="width: 30%;" type="danger"
					@click="addBlacklist()">{{ text01 }}</el-button>
				<el-button size="medium" style="width: 30%;" type="danger"
					@click="addBlackIp()">{{ text03 }}</el-button>
			</div>
		</div>

		<div style="flex: 1; overflow-y: auto; padding: 20px; box-sizing: border-box;">

			<div
				style="background: #fff; border-radius: 8px; padding: 20px; border: 1px solid #ebeef5; margin-bottom: 20px;">
				<div
					style="font-size: 15px; font-weight: bold; color: #333; margin-bottom: 15px; border-left: 4px solid #007AFF; padding-left: 10px; display: flex; align-items: center;">
					<i class="el-icon-apple" style="margin-right: 5px; font-size: 18px;"></i>
					iOS 终端审计数据详情
				</div>

				<el-descriptions :column="4" border size="small">
					<el-descriptions-item label="ID">{{ handleEmptyDeviceDetail(data.id) }}</el-descriptions-item>
					<el-descriptions-item label="请求ID (Seq)"
						:span="3">{{ handleEmptyDeviceDetail(data.sequenceId) }}</el-descriptions-item>

					<el-descriptions-item label="iOS设备标识 (IDFV)" :span="2">
						<span
							style="word-break: break-all; font-family: monospace;">{{ handleEmptyDeviceDetail(data.idfv) }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="本地生产设备ID" :span="2">
						<span
							style="word-break: break-all; font-family: monospace;">{{ handleEmptyDeviceDetail(data.deviceId) }}</span>
					</el-descriptions-item>

					<el-descriptions-item label="越狱状态" :span="2">
						<el-tag :type="data.auxo === 2 ? 'danger' : (data.auxo === 3 ? 'warning' : 'success')"
							size="mini" effect="dark">
							{{ data.auxo === 1 ? '未越狱' : data.auxo === 2 ? '已越狱' : data.auxo === 3 ? '越狱失效' : '未知' }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="反越狱插件">
						<el-tag :type="data.isAntiJailbreak === 0 ? 'info' : 'warning'" size="mini">
							{{ data.isAntiJailbreak === 0 ? '无' : '检测到(有)' }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="CydiaSubstrate">
						<el-tag :type="data.isCydiaSubstrate === 0 ? 'info' : 'warning'" size="mini">
							{{ data.isCydiaSubstrate === 0 ? '无' : '检测到(有)' }}
						</el-tag>
					</el-descriptions-item>

					<el-descriptions-item
						label="设备名称">{{ handleEmptyDeviceDetail(data.deviceName) }}</el-descriptions-item>
					<el-descriptions-item label="手机型号">{{ handleEmptyDeviceDetail(data.model) }}</el-descriptions-item>
					<el-descriptions-item label="系统版本">iOS
						{{ handleEmptyDeviceDetail(data.osVersion) }}</el-descriptions-item>
					<el-descriptions-item
						label="Mac序列号">{{ handleEmptyDeviceDetail(data.macSerialnumber) }}</el-descriptions-item>

					<el-descriptions-item label="屏幕宽度">{{ handleEmptyDeviceDetail(data.screenWidth) }}
						px</el-descriptions-item>
					<el-descriptions-item label="屏幕高度">{{ handleEmptyDeviceDetail(data.screenHeight) }}
						px</el-descriptions-item>
					<el-descriptions-item
						label="CPU 使用率">{{ handleEmptyDeviceDetail(data.cpuUseRate) }}</el-descriptions-item>
					<el-descriptions-item
						label="运营商名称">{{ handleEmptyDeviceDetail(data.carrierName) }}</el-descriptions-item>

					<el-descriptions-item label="硬盘大小 (Byte)"
						:span="2">{{ handleEmptyDeviceDetail(data.totalDiskSpace) }}</el-descriptions-item>
					<el-descriptions-item label="总内存 (Byte)"
						:span="2">{{ handleEmptyDeviceDetail(data.totalMemory) }}</el-descriptions-item>

					<el-descriptions-item
						label="当前电量">{{ handleEmptyDeviceDetail(data.batteryLevel) }}%</el-descriptions-item>
					<el-descriptions-item label="电池/充电状态" :span="2">
						<el-tag size="mini" type="info">
							{{
								data.chargeStatus === 0 ? '未开启电池权限' :
								data.chargeStatus === 1 ? '未充电' :
								data.chargeStatus === 2 ? '充电中 (电量 < 100%)' :
								data.chargeStatus === 3 ? '充电已充满' : '未知'
							}}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="网络连接">
						<el-tag size="mini" effect="plain">{{
							data.networkType === 1 ? 'WIFI' : data.networkType === 2 ? '2G' :
							data.networkType === 3 ? '3G' : data.networkType === 4 ? '4G' : '异常/未知'
						}}</el-tag>
					</el-descriptions-item>

					<el-descriptions-item label="开机时间"
						:span="2">{{ handleEmptyDeviceDetail(data.bootTime) }}</el-descriptions-item>
					<el-descriptions-item label="创建时间"
						:span="2">{{ handleEmptyDeviceDetail(data.createTime) }}</el-descriptions-item>
					<el-descriptions-item label="运营商标识 (UAID)"
						:span="4">{{ handleEmptyDeviceDetail(data.uaid) }}</el-descriptions-item>
				</el-descriptions>
			</div>

			<div v-if="auditData"
				style="background: #fff; border-radius: 8px; overflow: hidden; border: 1px solid #ebeef5; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
				<div :style="{
					padding: '16px 20px',
					background: '#fcfdfe',
					borderLeft: '4px solid ' + riskConfig(auditData.riskControl).color,
					borderBottom: '1px solid #f0f2f5'
				}">
					<div style="display: flex; align-items: center; justify-content: space-between;">
						<div style="display: flex; align-items: center; gap: 12px;">
							<span style="font-size: 16px; font-weight: bold; color: #333;">AI 智能审计报告</span>
							<el-tag :type="riskConfig(auditData.riskControl).type" effect="dark"
								size="small">{{ riskConfig(auditData.riskControl).label }}</el-tag>
							<div style="margin-top: 15px; text-align: right; font-size: 11px; color: #c0c4cc;">id:
								{{ auditData.userId }}
							</div>
						</div>
						<div style="font-size: 12px; color: #909399;">生成日期: {{ auditData.createTime }}</div>
					</div>
				</div>

				<div style="padding: 20px;">
					<div style="display: flex; gap: 20px; margin-bottom: 20px;">
						<div style="flex: 1; background: #f8f9fb; padding: 15px; border-radius: 6px;">
							<div style="font-size: 12px; color: #666; margin-bottom: 8px; font-weight: bold;">审核结论</div>
							<div style="font-size: 14px; color: #409eff; font-weight: bold;">
								{{ auditData.auditResults }}
							</div>
						</div>
						<div
							style="flex: 1; background: #fcf6ed; padding: 15px; border-radius: 6px; border: 1px solid #fdf6ec;">
							<div style="font-size: 12px; color: #e6a23c; margin-bottom: 8px; font-weight: bold;">AI
								核心异常点</div>
							<div style="font-size: 13px; color: #af7a2a; font-weight: 500;">{{ auditData.outLier }}
							</div>
						</div>
					</div>

					<div style="margin-top: 15px;">
						<div style="font-size: 13px; font-weight: bold; color: #606266; margin-bottom: 8px;">审计详细描述
						</div>
						<div
							style="padding: 12px; background: #fdfdfd; border: 1px dashed #dcdfe6; border-radius: 4px; font-size: 13px; color: #666; line-height: 1.6;">
							{{ auditData.judgmentDescription }}
						</div>
					</div>

					<div
						style="margin-top: 20px; background: #f0f7ff; border-radius: 8px; padding: 16px; border: 1px solid #e1f0ff;">
						<div
							style="font-size: 13px; font-weight: bold; color: #406e99; margin-bottom: 10px; display: flex; align-items: center;">
							<i class="el-icon-cpu" style="margin-right: 8px; font-size: 16px;"></i> AI 推理路径 (Thought
							Process)
						</div>
						<div style="font-size: 13px; line-height: 1.7; color: #406e99;">
							{{ auditData.thoughtProcess }}
						</div>
					</div>
					<div style="margin-top: 15px; text-align: right; font-size: 11px; color: #c0c4cc;">UID:
						{{ auditData.userId }}
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				sequenceId: '', //信息序号
				deviceId: '', //设备ID
				userId: '', //用户ID
				country: '', //国码
				id: '', //记录的ID
				phoneNumber: '', //手机号
				ip: '', //IP
				data: '', //接口返回的数据
				message: "", //提示的内容
				successfulOperation: false, //操作成功
				operationFailed: false, //操作失败
				deviceBaned: 0, // 该设备是否已被封禁 0-正常 1-已被封禁
				accountBaned: 0, //账号是否已被封禁  -3-用户已操作注销， 0-正常， 1-被禁言， 2-封号(未解绑设备) ，4-封号(已解绑设备) 
				ipBanded: 0, //0正常 1被封
				text01: "", //设备被封文本
				text02: "", //账号被封文本
				text03: "", //封禁IP
				auditData: null, // 用于存放接口返回的 AI 详情对象
				//...
			};
		},
		mounted() {
			this.sequenceId = this.$route.query.sequenceId;
			this.deviceId = this.$route.query.deviceId;
			this.userId = this.$route.query.userId;
			this.country = this.$route.query.country;
			this.id = this.$route.query.id;
			this.phoneNumber = this.$route.query.phoneNumber;
			this.ip = this.$route.query.ip;

			console.log('sequenceId:', this.sequenceId);
			console.log('userId:', this.userId);
			console.log('country:', this.country);
			console.log('id:', this.id);
			console.log('phoneNumber:', this.phoneNumber);
			console.log('ip:', this.ip);

			this.fetchData();
			this.getDeviceAiRiskControlBySequenceId();
		},
		methods: {
			fetchData() { //用户详情
				this.loadingData = true;

				const requestData = {}; //传递的参数
				requestData.sequenceId = this.sequenceId;
				requestData.userId = this.userId;

				axios.post(this.$p_url + '/admin/getDeviceIosInfoDetails', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.data = response.data.data.deviceIosInfo;
							this.deviceBaned = response.data.data.deviceBaned;
							this.accountBaned = response.data.data.accountBaned;
							this.ipBanded = response.data.data.ipBanded;

							switch (this.deviceBaned) { //该设备是否已被封禁
								case 0: //正常
									this.text01 = "封禁设备";
									break
								case 1: //已被封禁
									this.text01 = "该设备已经被封";
									break
							}

							switch (this.accountBaned) { //账号是否已被封禁
								case -3: //用户已操作注销
									this.text02 = "用户已操作注销";
									break
								case 0: //正常
									this.text02 = "封禁账号";
									break
								case 1: //被禁言
									this.text02 = "该账号被禁言";
									break
								case 2: //封号(未解绑设备)
									this.text02 = "被封号(未解绑设备)";
									break
								case 4: //封号(已解绑设备)
									this.text02 = "已封号(已解绑设备)";
									break
							}

							switch (this.ipBanded) { //IP是否已被封禁
								case 0: //正常
									this.text03 = "封禁IP";
									break
								case 1: //已被封禁
									this.text03 = "IP被封";
									break
							}


						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			getDeviceAiRiskControlBySequenceId() { //获取AI审核的详情
				const requestData = {}; //传递的参数
				requestData.sequenceId = this.sequenceId;

				axios.post(this.$p_url + '/admin/getDeviceAiRiskControlBySequenceId', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("获取AI审核的详情：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.auditData = response.data.data;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			banAccount() { //封禁账号
				if (this.accountBaned == 0) {
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/black/' + this.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁账号成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else { // 处理状态为失败的情况
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				}
			},
			addBlacklist() { //封禁设备
				if (this.deviceBaned == 0) {
					this.loadingData = true;

					const requestData = {}; //传递的参数
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/deviceId', requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("后台数据返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁设备成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			addBlackIp() { //封禁IP
				if (this.ipBanded == 0) {
					this.loadingData = true;

					const requestData = {};
					requestData.ip = this.ip;
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/ip', requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁IP：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁IP成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			handleEmptyDeviceDetail(value) {
				return value ? value : '-'; // 如果值为空，则返回占位符 '-'
			},
			riskConfig(level) {
				const configs = {
					3: {
						type: 'danger',
						label: '高风险',
						icon: 'el-icon-error',
						color: '#F56C6C'
					},
					2: {
						type: 'warning',
						label: '中风险',
						icon: 'el-icon-warning',
						color: '#E6A23C'
					},
					1: {
						type: 'info',
						label: '低风险',
						icon: 'el-icon-info',
						color: '#909399'
					},
					0: {
						type: 'success',
						label: '正常',
						icon: 'el-icon-success',
						color: '#67C23A'
					},
					4: {
						type: 'info',
						label: '数据缺失',
						icon: 'el-icon-warning-outline',
						color: '#DCDFE6'
					}
				};
				return configs[level] || configs[4];
			}
			//...
		},

		//....
	}
</script>

<style>
</style>